import gql from 'graphql-tag';

import { INVENTORY_OPTION_FRAGMENT } from './fragments';

export const CREATE_INVENTORY_OPTION = gql`
  mutation CreateInventoryOption($input: CreateInventoryOptionInput!) {
    createInventoryOption(input: $input) {
      ...InventoryOptionFields
    }
  }
  ${INVENTORY_OPTION_FRAGMENT}
`;

export const UPDATE_INVENTORY_OPTION = gql`
  mutation UpdateInventoryOption($input: UpdateInventoryOptionInput!) {
    updateInventoryOption(input: $input) {
      ...InventoryOptionFields
    }
  }
  ${INVENTORY_OPTION_FRAGMENT}
`;

export const DELETE_INVENTORY_OPTION = gql`
  mutation DeleteInventoryOption($input: DeleteInventoryOptionInput!) {
    deleteInventoryOption(input: $input) {
      success
      message
    }
  }
`;
